module.exports = __webpack_public_path__ + "static/media/7_3.6dc9e167.jpg";